import React, { useState } from 'react';
import axios from 'axios';
import { Nav, Button, Collapse, Card, Spinner } from 'react-bootstrap';
import { Link, useLocation, useHistory } from 'react-router-dom';
import {
    FiMenu,
    FiUser,
    FiBook,
    FiFileText,
    FiVideo,
    FiLock,
    FiShoppingBag,
    FiPackage,
    FiLogOut
} from 'react-icons/fi';

const Sidebar = () => {
    const location = useLocation();
    const history = useHistory();
    const [open, setOpen] = useState(false);
    const [isLoggingOut, setIsLoggingOut] = useState(false); // 🔄 New state
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

    const menu = [
        { label: 'Edit Profile', path: '/dashboard/profile', icon: <FiUser className="me-2" /> },
        { label: 'Course', path: '/dashboard/courses', icon: <FiBook className="me-2" /> },
        { label: 'Content', path: '/dashboard/content', icon: <FiFileText className="me-2" /> },
        { label: 'Consultation', path: '/dashboard/consultation', icon: <FiVideo className="me-2" /> },
        { label: 'Community', path: '/dashboard/community', icon: <FiPackage className="me-2" /> },
        { label: 'Audit', path: '/dashboard/audit', icon: <FiPackage className="me-2" /> },
        { label: 'Affiliate', path: '/dashboard/affiliate', icon: <FiLock className="me-2" /> },
        { label: 'Order History', path: '/dashboard/orders', icon: <FiShoppingBag className="me-2" /> },
        { label: 'Logout', action: 'logout', icon: <FiLogOut className="me-2" /> }
    ];

    const navLinkStyle = (isActive) => ({
        backgroundColor: isActive ? '#f0f2f5' : 'transparent',
        fontWeight: isActive ? '600' : '400',
        padding: '10px 15px',
        borderRadius: '8px',
        color: '#212529',
        display: 'flex',
        alignItems: 'center',
        textDecoration: 'none',
        marginBottom: '5px',
        transition: '0.3s ease',
        cursor: 'pointer'
    });

    const handleItemClick = async (item) => {
        if (item.action === 'logout') {
            setIsLoggingOut(true); // ✅ Start loading
            try {
                const token = localStorage.getItem('token');
                await axios.post(
                    `${API_BASE_URL}/customer/logout`,
                    {},
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );

                // Clear localStorage and redirect
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                localStorage.removeItem('token_created_at');

                history.push('/login');
            } catch (error) {
                console.error('Logout failed:', error);
                alert('Failed to logout. Please try again.');
                setIsLoggingOut(false);
            }
        } else if (item.path) {
            history.push(item.path);
            setOpen(false);
        }
    };

    const renderNavItems = () =>
        menu.map((item, index) => (
            <Nav.Item key={index}>
                <div
                    onClick={() => handleItemClick(item)}
                    style={navLinkStyle(location.pathname === item.path)}
                >
                    {item.icon}
                    {item.label}
                    {item.action === 'logout' && isLoggingOut && (
                        <Spinner
                            animation="border"
                            size="sm"
                            role="status"
                            className="ms-2 text-primary"
                        >
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    )}
                </div>
            </Nav.Item>
        ));

    return (
        <Card className="p-3 shadow-sm border-0" style={{ minHeight: '100%' }}>
            {/* Mobile Toggle Button */}
            <div className="d-md-none mb-3">
                <Button
                    variant="primary"
                    onClick={() => setOpen(!open)}
                    aria-controls="sidebar-collapse"
                    aria-expanded={open}
                    className="w-100"
                >
                    <FiMenu className="me-2" />
                    Dashboard Menu
                </Button>
            </div>

            {/* Collapsible for small devices */}
            <Collapse in={open}>
                <div id="sidebar-collapse" className="d-md-none">
                    <Nav className="flex-column mt-3">{renderNavItems()}</Nav>
                </div>
            </Collapse>

            {/* Sidebar for md+ screens */}
            <div
                className="d-none d-md-block"
                style={{
                    height: '100vh',
                    overflowY: 'auto',
                    position: 'sticky',
                    top: '0'
                }}
            >
                <h5 className="mb-3 fw-bold">User Dashboard</h5>
                <Nav className="flex-column">{renderNavItems()}</Nav>
            </div>
        </Card>
    );
};

export default Sidebar;
